import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import SVGWrapper from '../../SVGWrapper/index.js';
import { StyledDelete } from './style.js';

function Close(_a) {
    var _b = _a.color, color = _b === void 0 ? '#212529' : _b, onClick = _a.onClick, style = _a.style, props = __rest(_a, ["color", "onClick", "style"]);
    return (React.createElement(SVGWrapper, __assign({ width: 24, height: 24, onClick: onClick, style: style }, props),
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z", fill: color })));
}
function Delete(_a) {
    var _b = _a.color, color = _b === void 0 ? '#868E96' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, style = _a.style, props = __rest(_a, ["color", "disabled", "onClick", "style"]);
    return (React.createElement(StyledDelete, __assign({ width: 24, height: 24, disabled: disabled, onClick: disabled ? undefined : onClick, style: style }, props),
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", clipRule: "evenodd", d: "M4 12C4 7.576 7.576 4 12 4C16.424 4 20 7.576 20 12C20 16.424 16.424 20 12 20C7.576 20 4 16.424 4 12ZM14.872 16L16 14.872L13.128 12L16 9.128L14.872 8L12 10.872L9.128 8L8 9.128L10.872 12L8 14.872L9.128 16L12 13.128L14.872 16Z", fill: color })));
}
function XShape(_a) {
    var styleType = _a.styleType, color = _a.color, disabled = _a.disabled, onClick = _a.onClick, style = _a.style, props = __rest(_a, ["styleType", "color", "disabled", "onClick", "style"]);
    switch (styleType) {
        case 'close':
            return React.createElement(Close, __assign({ color: color, onClick: onClick, style: style }, props));
        case 'delete':
            return (React.createElement(Delete, __assign({ color: color, disabled: disabled, onClick: onClick, style: style }, props)));
    }
}

export { XShape as default };
